import React from 'react'
import "../../Css/install.css"


export default function Head() {
  return (
    <>
      
      <section className='install mb-3' id="hero">
        <div className='container'>

          <h1><span className='highlight' style={{ borderBottom: "10px solid #808000" }}>Create your Polygon Token</span></h1>
          <p>
            Easily deploy your Smart Contract for a Standard, Capped, Mintable, Burnable ERC20 Token.
            <br />No login. No setup. No coding required.
          </p>

        </div>
      </section>
    </>
  )

}
